import ClaimTypeAutomationRule from 'models/claims/claimTypeAutomationRule/Model.ClaimTypeAutomationRule';
import Model from 'models/Model';
import Dealer from '../dealer/Model.Dealer';

export default class ClaimTypeDealerAutomationRule
  extends Model<Model.IClaimTypeDealerAutomationRule>({ icon: 'if-login' })
  implements Model.Instance<Model.IClaimTypeDealerAutomationRule>
{
  id: number;
  logicalLayout: Model.Automation.ILayoutToken[];
  expressions: Model.Automation.IExpression[];
  effects: Model.Automation.IEffect[];

  claimTypeAutomationRuleId: number;
  claimTypeAutomationRule?: ClaimTypeAutomationRule;
  dealerId: number;
  dealer?: Dealer;

  claimTypeId?: number;

  constructor(
    data: Partial<Model.IClaimTypeDealerAutomationRule> | Utils.FormData<Model.IClaimTypeDealerAutomationRule>,
    language?: Locale.Languages
  ) {
    super(
      {
        claimTypeAutomationRule: ClaimTypeAutomationRule,
        dealer: Dealer,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.claimTypeAutomationRule?.claimType?.name || this.id?.toString(),
    };
  }
}
